import { numberWithCommas } from "../helpers/app/numberFormater";
import {
  drawApprovalTable,
  drawDetailsTable,
  drawExpensesTable,
  drawFormHeader,
  formatPdfDate,
  renderSinglePageForm,
  personName,
} from "../helpers/app/formPdf";

const generatePaymentVoucherPdf = (data, currency) => {
  const money = (amount) =>
    `${currency === "D" ? "USD" : "UGX"} ${numberWithCommas(amount)}`;

  const doc = renderSinglePageForm((doc, layout) => {
    let y = drawFormHeader(
      doc,
      "AMANI INITIATIVE FUNDS ADVANCE/WITHDRAW FORM",
      layout
    );

    y = drawDetailsTable(
      doc,
      [
        ["Date:", formatPdfDate(data.created_at)],
        ["Funds Advance/Withdraw Form Number:", data.id],
        ["Donor:", data.projectDetails?.donor_name],
        ["Project:", data.projectDetails?.project_name],
        ["Requisition Form Number:", data.requisitionMemoDetails?.memo_number],
        ["Bank:", data.bank],
        ["Cheque No.:", data.cheque_number],
        ["Payee:", personName(data?.payee)],
        ["Details:", data.requisitionMemoDetails?.details],
      ],
      y,
      layout
    );

    let total = 0;
    const rows = (data.requisitionMemoDetails?.activities || []).map(
      (activity) => {
        total += activity.total_cost;
        return [
          activity.name,
          numberWithCommas(activity.units),
          money(activity.unit_cost),
          money(activity.total_cost),
        ];
      }
    );
    y = drawExpensesTable(
      doc,
      "Payment Voucher Particulars",
      ["Particulars", "Units", "Unit Cost", "Total Amount"],
      rows,
      ["Total", "", "", money(total)],
      y,
      layout
    );

    y = drawApprovalTable(
      doc,
      [
        { label: "Prepared", person: data?.creator, date: data.created_at },
        { label: "Checked", person: data?.checker, date: data.checked_at },
        { label: "Approved", person: data?.approver, date: data.approved_at },
      ],
      y,
      layout
    );

    return y;
  });
  doc.save("AMANI INITIATIVE FUNDS ADVANCE/WITHDRAW FORM");
};

export default generatePaymentVoucherPdf;
